import React from 'react';
import { 
  Box, 
  Typography, 
  FormControl, 
  FormControlLabel, 
  RadioGroup, 
  Radio,
  Paper,
  Divider
} from '@mui/material';
import ThermostatIcon from '@mui/icons-material/Thermostat';

const ClimaConfig = ({ config, onChange }) => {
  const handleUnidadeChange = (event) => {
    onChange({
      ...config,
      unidade: event.target.value
    });
  };

  // Conversão de Celsius para Fahrenheit
  const celsiusParaFahrenheit = (celsius) => {
    return (celsius * 9/5) + 32;
  };

  // Exemplo de temperatura para visualização
  const getExemploTemperatura = () => {
    const temperaturaCelsius = 25;
    
    if (config.unidade === 'C') {
      return `${temperaturaCelsius}°C`;
    } else {
      const temperaturaFahrenheit = Math.round(celsiusParaFahrenheit(temperaturaCelsius));
      return `${temperaturaFahrenheit}°F`;
    }
  };

  return (
    <Paper sx={{ p: 2, borderRadius: 2, flex: 1, minWidth: 250 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <ThermostatIcon sx={{ mr: 1, color: 'primary.main' }} />
        <Typography variant="h6">
          Formato do Clima
        </Typography>
      </Box>
      
      <Divider sx={{ mb: 2 }} />
      
      <FormControl component="fieldset">
        <Typography variant="subtitle2" gutterBottom sx={{ mb: 1 }}>
          Unidade de temperatura:
        </Typography>
        <RadioGroup
          value={config.unidade}
          onChange={handleUnidadeChange}
        >
          <FormControlLabel value="C" control={<Radio />} label="Celsius (°C)" />
          <FormControlLabel value="F" control={<Radio />} label="Fahrenheit (°F)" />
        </RadioGroup>
      </FormControl>

      <Box sx={{ mt: 3, p: 2, bgcolor: 'background.default', borderRadius: 1 }}>
        <Typography variant="caption" display="block" gutterBottom>
          VISUALIZAÇÃO:
        </Typography>
        <Typography variant="h5" sx={{ fontFamily: 'monospace', fontWeight: 'medium' }}>
          {getExemploTemperatura()}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          NUBLADO
        </Typography>
      </Box>
    </Paper>
  );
};

export default ClimaConfig; 